import type { AccountMetricsFetchedPayload } from '@Application/AccountMetrics/Actions/accountMetricsFetched';
import OrganizationMetricsView from '@UI/Store/AccountMetrics/Views/OrganizationMetricsView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AccountMetricsView {
	readonly organizationCount: number;
	readonly facilityCount: number;
	readonly userCount: number;
	readonly organizations: readonly OrganizationMetricsView[];

	constructor(payload: AccountMetricsFetchedPayload) {
		this.organizationCount = payload.totals.organizationCount;
		this.facilityCount = payload.totals.facilityCount;
		this.userCount = payload.totals.userCount;
		this.organizations = payload.organizations.map(
			(organization) => new OrganizationMetricsView(organization),
		);

		Object.freeze(this);
	}
}

export default AccountMetricsView;
